import { createAction, props } from '@ngrx/store';

import { Quote } from '@lockton-apps/shared/interfaces';

export enum QuoteDetailsActionTypes {
  Init = '[QuoteDetails/Page] Init',

  QuoteApproved = '[QuoteDetails/Page] Quote Approved',

  QuoteCompleted = '[QuoteDetails/Page] Quote Completed',

  ReQuoted = '[QuoteDetails Page] Re-Quoted',

  ChangesRequested = '[QuoteDetails/Page] Changes Requested',

  Destroyed = '[QuoteDetails Page] Destroyed',
}

export const QuoteDetailsActions = {
  init: createAction(QuoteDetailsActionTypes.Init),
  quoteApproved: createAction(
    QuoteDetailsActionTypes.QuoteApproved,
    props<{ quote: Quote }>()
  ),
  quoteCompleted: createAction(
    QuoteDetailsActionTypes.QuoteCompleted,
    props<{ quote: Quote }>()
  ),
  reQuoted: createAction(
    QuoteDetailsActionTypes.ReQuoted,
    props<{ quote: Quote }>()
  ),
  changesRequested: createAction(
    QuoteDetailsActionTypes.ChangesRequested,
    props<{ quote: Quote }>()
  ),
  destroyed: createAction(QuoteDetailsActionTypes.Destroyed),
};
